<template>
  <div id="app">
    <!-- 登录和注册页面不显示头部 -->
    <app-header v-if="showHeader"></app-header>
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from './components/Header.vue'

export default {
  name: 'App',
  components: {
    AppHeader
  },
  computed: {
    showHeader() {
      // 在登录和注册页面不显示头部
      return !['LoginPage', 'RegisterPage'].includes(this.$route.name);
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
}

body {
  margin: 0;
  padding: 0;
  height: 100%;
}

html {
  height: 100%;
  scroll-behavior: smooth;
}

.main-content {
  flex: 1;
}
</style> 